import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import Modal from "../../../components/portal/Modal";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import successIcon from "../../../assets/icons/successIcon.svg";

export default function AddVehicleSuccess({ viewDetails }) {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Vehicle Successfully Added!</p>
      <div className={`px-2 overflow-auto`}>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Vehicle Number" value={viewDetails.vehicleNumber} />
          <DetailRow title="Driver Name" value={viewDetails.driverName} />
          <DetailRow title="Driver Phone" value={viewDetails.driverMobile} />
          <DetailRow
            title="Vehicle Reading"
            value={viewDetails.vehicleReading}
          />
          <DetailRow title="Vehicle Model" value={viewDetails.vehicleModel} />
        </div>
      </div>
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/sites/cylinders")}
        />
      </div>
    </Modal>
  );
}
